import axios from 'axios';
import { MessageBox, Message,Loading } from 'element-ui';
//axios拦截器
const request = axios.create({
    //baseURL:'/api',
    //timeout:5000
 })
let loadingInstance = null;//loading对象
let needLoadingRequestCount = 0;//当前请求的数量
/*
* 参数
*   loading:true|false 表示是否加载loading效果
* */
/*拦截*/
request.interceptors.request.use(
    config => {
        return config
    },
    error => {
        loadingInstance && loadingInstance.close();
        return Promise.reject(error.response);
    }
)

request.interceptors.response.use(

    response => {
        if(response.data.msg=='tokenMissing'||response.data.msg=='tokenExpired'||response.data.msg=='tokenIllegal'){
            window.$vue.$router.push({path: '/'})
            window.localStorage.clear();
        }
        return response.data;
    },
    error => {
        Message({
            message: error.response,
            type: "error",
            duration: 3 * 1000
        });
        return Promise.reject(error.response);
    }
)

export default request
